import { ITaskCalendarFilter } from './interfaces'
import {
  setCalendarData,
  setCalendarDataLoading,
  setCalendarFailed,
  setCalendarOptions,
  setCalendarCaseTypes,
  setCalendarCaseTypesFailed,
  setCalendarClaimTypesFailed,
  setCalendarClaimTypes,
} from './actions'
import fetchAPI, { IHttpError } from '../../../lib/utils/fetch-api'

export function getTasksListToCalendar(filter?: ITaskCalendarFilter) {
  return async dispatch => {
    dispatch(setCalendarDataLoading())
    try {
      const cleanFilter: any = {}
      if (filter) {
        Object.keys(filter).forEach(key => {
          const value = filter[key]
          if (value !== undefined && value !== null && value !== '') {
            cleanFilter[key] = value
          }
        })
      }
      
      const params = new URLSearchParams(cleanFilter)
      params.set('pageSize', 'all')
      const response = (await fetchAPI(`/api/v2/tasks?${params.toString()}`)) || []
      if (response?.error) {
        let error = response.error
        return dispatch(setCalendarFailed(error))
      }
      dispatch(setCalendarOptions(response?.options || []))
      return dispatch(setCalendarData(response.data))
    } catch (err) {
      console.error(err)
      const message = (err as IHttpError)?.message || 'При загрузки полей возникла ошибка'
      const statusCode = (err as IHttpError)?.statusCode || 'error'
      return dispatch(setCalendarFailed({ message, statusCode }))
    }
  }
}

export function getTaskCaseEnum() {
  return async dispatch => {
    try {
      const response = await fetchAPI(`/api/v2/task/case/enum`)
      if (response?.error || response?.errors) {
        let error = response.error || response.errors
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setCalendarCaseTypesFailed(error))
      }
      return dispatch(setCalendarCaseTypes(response || []))
    } catch (err) {
      console.error(err)
      const message = (err as IHttpError)?.message || 'При загрузки полей возникла ошибка'
      const statusCode = (err as IHttpError)?.statusCode || 'error'
      return dispatch(setCalendarCaseTypesFailed({ message, statusCode }))
    }
  }
}

export function getTaskClaimEnum() {
  return async dispatch => {
    try {
      const response = await fetchAPI(`/api/v2/task/claim/enum`)
      if (response?.error || response?.errors) {
        let error = response.error || response.errors
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setCalendarClaimTypesFailed(error))
      }
      return dispatch(setCalendarClaimTypes(response || []))
    } catch (err) {
      console.error(err)
      const message = (err as IHttpError)?.message || 'При загрузки полей возникла ошибка'
      const statusCode = (err as IHttpError)?.statusCode || 'error'
      return dispatch(setCalendarClaimTypesFailed({ message, statusCode }))
    }
  }
}
